export default __webpack_public_path__ + "assets/bathrooms.9188385e.svg";